module.exports = __webpack_public_path__ + "static/media/new_level_photo_bg.87db9bcd.png";